import PropTypes from 'prop-types';
import { List, ListItemButton, ListItemText, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function SensorSelectList({ sensors, selectedId, onSelect }) {
  return (
    <Box>
      <List>
        {sensors.map((s) => (
          <ListItemButton key={s.id} selected={s.id === selectedId} onClick={() => onSelect(s.id)}>
            <ListItemText primary={s.name} secondary={s.serialNumber} />
          </ListItemButton>
        ))}
      </List>
      <Button component={RouterLink} to="/dashboard/sensor-manager" size="small">
        Connect a sensor
      </Button>
    </Box>
  );
}

SensorSelectList.propTypes = {
  sensors: PropTypes.array.isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};
